function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_tests_icon_svg__cls-1{fill:#b4c0cf}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_tests_icon_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_tests_icon_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_tests_icon_svg__cls-1",
  d: "M7 16.54H3.12a1.35 1.35 0 01-1.37-1.33V3.08a1.35 1.35 0 011.37-1.33h9.47a1.34 1.34 0 011.36 1.33v10.16l1.75-2.08V1.78A1.76 1.76 0 0013.93 0H1.7A1.7 1.7 0 000 1.71v14.84a1.77 1.77 0 001.77 1.78h6.87l-.81-.7A3.09 3.09 0 017 16.54zm0 0"
}), React.createElement("path", {
  className: "bespoken_tests_icon_svg__cls-1",
  d: "M11.85 4H4a.87.87 0 000 1.74h7.85a.87.87 0 000-1.75zm0 0M11.85 6.91H4a.87.87 0 100 1.74h7.85a.87.87 0 000-1.75zm0 0M11.85 9.82H4a.85.85 0 100 1.7h7.85a.85.85 0 100-1.7zm0 0M3.13 13.45a.85.85 0 00.87.85h2.93a3.54 3.54 0 01.57-1 3.15 3.15 0 01.94-.73H4a.86.86 0 00-.87.86zm0 0M11.85 12.6h-.65a2.33 2.33 0 01.61.4l.87.75a.8.8 0 00.05-.29.87.87 0 00-.87-.86zm0 0"
}), React.createElement("path", {
  className: "bespoken_tests_icon_svg__cls-1",
  d: "M20.49 10.26a1.52 1.52 0 00-2.15.17l-5 5.88-2.51-2.15a1.53 1.53 0 10-2 2.31l3.67 3.15a1.54 1.54 0 001 .37h.12a1.51 1.51 0 001-.53l6-7a1.52 1.52 0 00-.18-2.15zm0 0"
})));

var SvgBespokenTestsIcon = function SvgBespokenTestsIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 21.03 20"
  }, props), _ref, _ref2);
};

export default SvgBespokenTestsIcon;